module.exports = __webpack_public_path__ + "img/preferably.754d3af9.png";